import unitConverter from '../utils/unitConverter'
// import Constant from './Constant'

// const {DAS_FLAG_MAP} = Constant

export default class DataFormatter {
  static format (currentQuery, otherDimensionProp, formatter, oDataListProp, dataListProp) {
    let {dimension} = this
    let otherDimension = dimension ^ 1

    let dimensionIdProps = new Array(2)
    dimensionIdProps[dimension] = 'siteId'
    dimensionIdProps[otherDimension] = otherDimensionProp
    let [dimensionIdProp0, dimensionIdProp1] = dimensionIdProps

    let dimensionIds = new Array(2)
    dimensionIds[dimension] = currentQuery.siteIds
    dimensionIds[otherDimension] = currentQuery.factorIds
    let [dimensionIds0, dimensionIds1] = dimensionIds

    let {siteFactorMap, factorSiteMap} = this
    let dimensionObjects = new Array(2)
    dimensionObjects[dimension] = siteFactorMap
    dimensionObjects[otherDimension] = factorSiteMap
    let dimensionObjectMap = dimensionObjects[0]

    let tmpList = this[oDataListProp]
    let {completeAllData} = this
    let beginTS = new Date(currentQuery.beginTime).getTime()
    let dataList = Object.values(tmpList.reduce((map, data) => {
      let newData = map[data[dimensionIdProp0]]

      if (newData) {
        let {dataTime} = data
        let ts = new Date(dataTime).getTime()

        if (ts > newData.endTS) {
          newData.endTS = ts
        }

        formatter(data, newData, dimensionIdProp1, ts, dataTime)
      }

      return map
    }, dimensionIds0.reduce((map, dimensionId) => {
      let dimensionObject = dimensionObjectMap[dimensionId]
      let subDimensionMap = dimensionObject.map
      let seriesDimensions = dimensionIds1.reduce((list, id) => {
        let dimensionObj = subDimensionMap[id]

        if (dimensionObj) {
          list.push(dimensionObj)
        }

        return list
      }, [])

      map[dimensionId] = {
        id: dimensionId,
        name: dimensionObject.name,
        beginTS,
        endTS: completeAllData ? new Date(currentQuery.endTime).getTime() : beginTS,
        dimensions: seriesDimensions,
        selectedNames: dimensionObject.selectedNames,
        seriesMap: seriesDimensions.reduce((map, seriesDimension) => {
          map[seriesDimension.id] = []
          return map
        }, {})
      }

      return map
    }, {})))

    let {unitProp} = this
    let data = Object.freeze(DataFormatter[`completeAndUnitConvert${currentQuery.dataType}`](dataList, unitProp))
    this.totalDataTimes = Object.freeze(data.totalDataTimes)
    this[dataListProp] = Object.freeze(data.dataList)
  }

  static format1 () {

  }

  static format2 (oDataListProp = 'tmpList', dataListProp = 'dataList') {
    console.time('format2')

    let {currentQuery} = this

    if (Object.keys(currentQuery).length === 0) {
      return
    }

    const {valueProp = 'value'} = this

    const {filterSiteMap} = this
    // const auditRuleFlagMap = {...(this.auditRuleFlagMap || {}), N: {name: '正常'}, X: {name: '数采标记异常'}}
    this[oDataListProp] = Object.freeze(this[oDataListProp].concat(Object.values(this.noDataReasonMap).reduce((list, noDataReason) => {
      const {siteId} = noDataReason
      const siteConfig = filterSiteMap[siteId]

      if (siteConfig) {
        const {siteDeviceId} = noDataReason
        const siteDeviceConfig = siteConfig.devices.find(siteDevice => siteDevice.id === siteDeviceId)

        if (siteDeviceConfig) {
          const {reason} = noDataReason
          const dataTime = `${noDataReason.dataTime}:00:00`
          siteDeviceConfig.siteDeviceFactors.forEach((siteDeviceFactor) => {
            list.push({
              dataTime,
              siteId,
              siteDeviceId,
              factorId: siteDeviceFactor.factorId,
              auditComment: reason,
              isAuditCompleted: true
            })
          })
        }
      }

      return list
    }, [])).sort((a, b) => a.dataTime.localeCompare(b.dataTime)))

    const queryIsAuditCompleted = currentQuery.isAuditCompleted
    const auditType = (queryIsAuditCompleted + 1) | (-currentQuery.isFuse & 3)

    DataFormatter.format.bind(this)(currentQuery, 'factorId', (data, newData, dimensionIdProp1, ts, dataTime) => {
      let value = data[valueProp]
      let series = newData.seriesMap[data[dimensionIdProp1]]

      if (series) {
        const displayFlags = []

        /** begin: 1 */
        // if (data.isHaveIntegral) {
        //   displayFlags.push('重积分')
        // } else if (Number.isFinite(value)) {
        //   const {dasFlag, flag} = data
        //   displayFlags.push(DAS_FLAG_MAP[dasFlag] || dasFlag)

        //   if (flag) {
        //     displayFlags.push(flag.split('|').map(flag => {
        //       const flagRule = auditRuleFlagMap[flag]
        //       return flagRule ? flagRule.name : flag
        //     }).join('|'))
        //   }
        // }

        // if (data.isAuditCompleted && (this.currentQuery.isAuditCompleted || this.currentQuery.isFuse)) {
        //   const {auditComment} = data

        //   if (auditComment) {
        //     displayFlags.push(auditComment)
        //   }
        // }
        /** end: 1 */

        /** begin: 2 */
        // const bin = auditType & (data.isAuditCompleted + 1)
        // const {isHaveIntegral} = data

        // if (bin === 2) {
        //   if (isHaveIntegral) {
        //     displayFlags.push('重积分')
        //   }

        //   const {auditComment} = data

        //   if (auditComment) {
        //     displayFlags.push(auditComment)
        //   }
        // } else if (bin === 1) {
        //   if (isHaveIntegral) {
        //     displayFlags.push('重积分')
        //   } else {
        //     displayFlags.push(data.dasFlag)
        //   }
        // }
        /** end: 2 */

        /** begin: 3 */
        const isAuditCompleted = (!!data.isAuditCompleted) + 1
        const bin = auditType & isAuditCompleted

        if (queryIsAuditCompleted === false || bin === 1) {
          if (data.isHaveIntegral) {
            displayFlags.push('')
          } else {
            displayFlags.push(data.dasFlag)
          }
        } else if (bin === 2) {
          const {value} = data

          if (Number.isFinite(value)) {
            const {auditFlag} = data

            if (auditFlag) {
              displayFlags.push(auditFlag === 'DELETE' ? 'O' : 'R', data.auditComment)
            }
          } else {
            displayFlags.push(data.auditComment)
          }
        }
        /** end: 3 */

        const newDataItem = {
          ...data,
          ts,
          dataTime,
          flag: data.flag || null,
          dasFlag: data.dasFlag || null,
          displayFlag: displayFlags.join(','),
          displayFlags
        }

        if (bin === 2 && data.auditFlag === 'DELETE') {
          delete newDataItem.value
          newDataItem.noDataReason = newDataItem.auditComment
        } else if (Number.isFinite(value)) {
          newDataItem.value = value
        } else {
          newDataItem.noDataReason = newDataItem.auditComment || ''
        }

        series.push(newDataItem)
      }
    }, oDataListProp, dataListProp)

    console.timeEnd('format2')
  }

  static format3 (oDataListProp = 'tmpList', dataListProp = 'dataList') {
    console.time('format3')

    let {currentQuery} = this

    if (Object.keys(currentQuery).length === 0) {
      return
    }

    let {dimension} = this

    DataFormatter.format.bind(this)(currentQuery, dimension === 0 ? currentQuery.factorIds : currentQuery.siteIds, (data, newData, dimensionIdProp1, ts, dataTime) => {
      let {seriesMap} = newData
      let dimensionIdsLen = dimensionIdProp1.length

      for (let i = 0; i < dimensionIdsLen; i++) {
        let dimensionId = dimensionIdProp1[i]
        let series = seriesMap[dimensionId]

        if (series) {
          let value = data[dimensionId]

          if (Number.isFinite(value)) {
            series.push({
              ts,
              dataTime,
              value,
              flag: data.flag || null
            })
          }
        }
      }
    }, oDataListProp, dataListProp)

    console.timeEnd('format3')
  }

  static format4 (oDataListProp = 'tmpList', dataListProp = 'dataList') {
    console.time('format4')

    let {currentQuery} = this

    if (Object.keys(currentQuery).length === 0) {
      return
    }

    let {dimension} = this
    let otherDimension = dimension ^ 1

    let dimensionIdProps = new Array(2)
    dimensionIdProps[dimension] = 'siteId'
    dimensionIdProps[otherDimension] = 'factorId'
    let [dimensionIdProp0] = dimensionIdProps

    let dimensionIds = new Array(2)
    dimensionIds[dimension] = currentQuery.siteIds
    dimensionIds[otherDimension] = currentQuery.factorIds
    let [dimensionIds0, dimensionIds1] = dimensionIds

    let {siteFactorMap, factorSiteMap, unitProp} = this
    let dimensionObjects = new Array(2)
    dimensionObjects[dimension] = siteFactorMap
    dimensionObjects[otherDimension] = factorSiteMap
    let dimensionObjectMap = dimensionObjects[0]
    let tmpList = this[oDataListProp]
    this[dataListProp] = Object.freeze(Object.values(tmpList.reduce((map, data) => {
      let newDataConfig = map[data[dimensionIdProp0]]

      if (newDataConfig) {
        newDataConfig.dataList = data.data.map(data => newDataConfig.dimensions.reduce((newData, dimension) => {
          let dimensionId = dimension.id
          let value = data[dimensionId]
          newData[dimensionId] = Number.isFinite(value) ? Number(unitConverter(data[dimensionId], dimension.stdUnit, dimension[unitProp], dimension.molecular).toFixed(3)) : '--'
          return newData
        }, {
          dataTime: data.dataTime
        }))
      }

      return map
    }, dimensionIds0.reduce((map, dimensionId) => {
      let dimensionObject = dimensionObjectMap[dimensionId]
      let subDimensionMap = dimensionObject.map
      let seriesDimensions = dimensionIds1.reduce((list, id) => {
        let dimensionObj = subDimensionMap[id]

        if (dimensionObj) {
          list.push(dimensionObj)
        }

        return list
      }, [])

      map[dimensionId] = {
        id: dimensionId,
        name: dimensionObject.name,
        dimensions: seriesDimensions,
        unitProp
      }

      return map
    }, {}))))

    console.timeEnd('format4')
  }

  // static completeAndUnitConvert60 (dataList, unitProp) {
  //   let dataListLen = dataList.length
  //   let totalDataTimeMap = {}
  //
  //   for (let i = 0; i < dataListLen; i++) {
  //     let data = dataList[i]
  //     let {beginTS, endTS, dimensions, seriesMap} = data
  //     let dimensionsLen = dimensions.length
  //     let dataTimeMap = {}
  //
  //     for (let j = 0; j < dimensionsLen; j++) {
  //       let dimension = dimensions[j]
  //       let {id, stdUnit, molecular, dataFrequency} = dimension
  //       let displayUnit = dimension[unitProp]
  //       let dataMap = {}
  //       let seriesData = seriesMap[id]
  //       let seriesDataIndex = 0
  //
  //       dataFrequency = (dataFrequency | 0) * 60000
  //       let _beginTS = seriesData.length > 0 ? seriesData[0].ts : beginTS
  //       let beginTS2 = _beginTS - dataFrequency
  //
  //       while (beginTS2 >= beginTS) {
  //         let date = new Date(beginTS2)
  //         let dataTime = date.format('YYYY/MM/DD HH:mm:ss')
  //         dataTimeMap[beginTS2] = totalDataTimeMap[beginTS2] = dataTime
  //         beginTS2 -= dataFrequency
  //       }
  //
  //       while (_beginTS <= endTS) {
  //         let currentData = seriesData[seriesDataIndex]
  //
  //         if (currentData) {
  //           let {ts, dataTime} = currentData
  //
  //           while (_beginTS < ts) {
  //             let date = new Date(_beginTS)
  //             let dataTime = date.format('YYYY/MM/DD HH:mm:ss')
  //
  //             dataTimeMap[_beginTS] = totalDataTimeMap[_beginTS] = dataTime
  //             _beginTS += dataFrequency
  //           }
  //
  //           currentData.value = Number(unitConverter(currentData.value, stdUnit, displayUnit, molecular).toFixed(3))
  //           dataMap[dataTime] = currentData
  //
  //           dataTimeMap[ts] = totalDataTimeMap[ts] = dataTime
  //           _beginTS = ts
  //           seriesDataIndex++
  //         } else {
  //           let date = new Date(_beginTS)
  //           let dataTime = date.format('YYYY/MM/DD HH:mm:ss')
  //           dataTimeMap[_beginTS] = totalDataTimeMap[_beginTS] = dataTime
  //         }
  //
  //         _beginTS += dataFrequency
  //       }
  //
  //       seriesMap[id] = dataMap
  //     }
  //
  //     data.dataTimes = Object.entries(dataTimeMap).map(dataTimes => [Number(dataTimes[0]), dataTimes[1]]).sort((a, b) => a[0] - b[0])
  //   }
  //
  //   return {
  //     dataList,
  //     totalDataTimes: Object.entries(totalDataTimeMap).map(dataTimes => [Number(dataTimes[0]), dataTimes[1]]).sort((a, b) => a[0] - b[0])
  //   }
  // }

  static formatWeatherDataList (dataList) {
    let {siteFactorMap, currentQuery} = this
    let factorIds = currentQuery.factorIds.filter(factorId => /^101(2|3)$/.test(factorId))

    if (factorIds.length === 2) {
      let siteDataMap = currentQuery.siteIds.reduce((map, siteId) => {
        let factorMap = siteFactorMap[siteId].map
        let windSpeed = factorMap['1012']

        if (windSpeed) {
          let windDir = factorMap['1013']

          if (windDir) {
            map[siteId] = {}
          }
        }

        return map
      }, {})

      let dataListLen = dataList.length

      for (let i = 0; i < dataListLen; i++) {
        let data = dataList[i]
        let siteData = siteDataMap[data.siteId]

        if (siteData && data.factorId === '1012') {
          siteData[data.dataTime] = data
        }
      }

      for (let i = 0; i < dataListLen; i++) {
        let data = dataList[i]
        let siteData = siteDataMap[data.siteId]

        if (siteData && data.factorId === '1013') {
          let {dataTime} = data
          let windSpeedData = siteData[dataTime]

          if (windSpeedData) {
            let {value} = data
            windSpeedData.symbolRotate = 180 - value
            windSpeedData.windDirect = value
            windSpeedData.windDirectDisplayFlag = data.dasFlag
          }
        }
      }
    }

    return dataList
  }

  // BAK
  static completeAndUnitConvert60 (dataList, unitProp) {
    let dataListLen = dataList.length
    let totalDataTimeMap = {}

    for (let i = 0; i < dataListLen; i++) {
      let data = dataList[i]
      let {beginTS, endTS, dimensions, seriesMap} = data
      let dimensionsLen = dimensions.length
      let dataTimeMap = {}

      for (let j = 0; j < dimensionsLen; j++) {
        let dimension = dimensions[j]
        let {id, stdUnit, molecular, dataFrequency, maxDelayTime} = dimension
        let displayUnit = dimension[unitProp]
        let dataMap = {}
        let seriesData = seriesMap[id]
        let seriesDataIndex = 0

        dataFrequency = (dataFrequency | 0) * 60000
        maxDelayTime = (maxDelayTime | 0) * 60000
        let interval = dataFrequency + maxDelayTime
        let _beginTS = seriesData.length > 0 ? seriesData[0].ts : beginTS
        let beginTS2 = _beginTS - interval

        while (beginTS2 >= beginTS) {
          let date = new Date(beginTS2)
          let dataTime = date.format('YYYY/MM/DD HH:mm:ss')
          dataTimeMap[beginTS2] = totalDataTimeMap[beginTS2] = dataTime
          beginTS2 -= interval
        }

        while (_beginTS <= endTS) {
          let currentData = seriesData[seriesDataIndex]

          if (currentData) {
            let {ts, dataTime} = currentData

            while (_beginTS < ts) {
              let date = new Date(_beginTS)
              let dataTime = date.format('YYYY/MM/DD HH:mm:ss')

              dataTimeMap[_beginTS] = totalDataTimeMap[_beginTS] = dataTime
              _beginTS += interval
            }

            if (currentData && Number.isFinite(currentData.value)) {
              currentData.value = Number(unitConverter(currentData.value, stdUnit, displayUnit, molecular).toFixed(3))
            }

            dataMap[dataTime] = currentData

            dataTimeMap[ts] = totalDataTimeMap[ts] = dataTime
            _beginTS = ts
            seriesDataIndex++
          } else {
            let date = new Date(_beginTS)
            let dataTime = date.format('YYYY/MM/DD HH:mm:ss')
            dataTimeMap[_beginTS] = totalDataTimeMap[_beginTS] = dataTime
          }

          _beginTS += interval
        }

        seriesMap[id] = dataMap
      }

      data.dataTimes = Object.entries(dataTimeMap).map(dataTimes => [Number(dataTimes[0]), dataTimes[1]]).sort((a, b) => a[0] - b[0])
    }

    return {
      dataList,
      totalDataTimes: Object.entries(totalDataTimeMap).map(dataTimes => [Number(dataTimes[0]), dataTimes[1]]).sort((a, b) => a[0] - b[0])
    }
  }
}



// WEBPACK FOOTER //
// ./src/model/DataFormatter.js